import apiClient from '../lib/apiClient';

// Get KPI data from API
const getKPIData = async () => {
  try {
    const result = await apiClient.get('/dashboard/kpi');
    return result;
  } catch (error) {
    return { success: false, error: error?.message || 'Failed to fetch KPI data' };
  }
};

// Get recent activities from API
const getRecentActivity = async () => {
  try {
    const result = await apiClient.get('/dashboard/activity');
    if (result.success && result.data) {
      const formattedActivities = result.data.map(activity => ({
        id: activity.id,
        user: activity.full_name || 'Unknown User',
        action: activity.action,
        description: activity.description,
        timestamp: new Date(activity.timestamp),
        type: activity.entity_type || 'system'
      }));
      return { success: true, data: formattedActivities };
    }
    return result;
  } catch (error) {
    return { success: false, error: error?.message || 'Failed to fetch recent activities' };
  }
};

// Get payroll trend data from API
const getPayrollTrendData = async () => {
  try {
    const result = await apiClient.get('/payroll/trend');
    return result;
  } catch (error) {
    return { success: false, error: error?.message || 'Failed to fetch payroll trend data' };
  }
};

// Get applicant funnel data from API
const getApplicantFunnelData = async () => {
  try {
    const result = await apiClient.get('/applications/funnel');
    return result;
  } catch (error) {
    return { success: false, error: error?.message || 'Failed to fetch applicant funnel data' };
  }
};

// Get invoice aging data from API
const getInvoiceAgingData = async () => {
  try {
    const result = await apiClient.get('/invoices/aging');
    return result;
  } catch (error) {
    return { success: false, error: error?.message || 'Failed to fetch invoice aging data' };
  }
};

// Get pending actions from API
const getPendingActions = async () => {
  try {
    const result = await apiClient.get('/dashboard/pendingActions');
    return result;
  } catch (error) {
    return { success: false, error: error?.message || 'Failed to fetch pending actions' };
  }
};

// Log dashboard activity
const logActivity = async (action, description, entityType = null, entityId = null) => {
  try {
    const result = await apiClient.post('/activity/log', {
      action,
      description,
      entity_type: entityType,
      entity_id: entityId
    });
    return result;
  } catch (error) {
    return { success: false, error: error?.message || 'Failed to log activity' };
  }
};

export default {
  getKPIData,
  getRecentActivity,
  getPayrollTrendData,
  getApplicantFunnelData,
  getInvoiceAgingData,
  getPendingActions,
  logActivity
};